module.exports = __webpack_public_path__ + "static/assets/dc5bd782fc4035e9bd2c5f4ce9c3a172.svg";